const _ = require('lodash');
const Promise = require('bluebird');

function _defer() {
	let resolve, reject;

	const promise = new Promise((_resolve, _reject) => {
		resolve = _resolve;
		reject = _reject;
	});

	return {
		resolve,
		reject,
		promise,
	};
}

class Bouncer {
	constructor({ eventNames = {} } = {}) {
		this._connectionDeferred = _defer();
		this._currentRooms = {};
		this._eventNames = eventNames;
		this._eventNames.join = this._eventNames.join || 'join-v2';
		this._eventNames.leave = this._eventNames.leave || 'leave-v2';

		this._forceReconnectHandler = this._forceReconnectHandler.bind(this);
		this._reconnectHandler = this._reconnectHandler.bind(this);
	}

	_getConnection() {
		return this._connectionDeferred.promise;
	}

	initialize({ connection }) {
		this.deinitialize(connection);
		this._connectionDeferred.resolve(connection);

		connection.on('socket_mgmt.force_reconnect', this._forceReconnectHandler);
		connection.on('reconnect', this._reconnectHandler);
	}

	_forceReconnectHandler() {
		console.log(`force_reconnect start`);

		this._getConnection()
			.then(connection => {
				console.log(`force_reconnect disconnect`);
				connection.disconnect();
				console.log(`force_reconnect disconnected`);
				setTimeout(() => {
					console.log(`force_reconnect connect`);
					connection.connect();
					console.log(`force_reconnect connected`);
				}, 3000);
			})
			.catch(err => {
				console.error(`Bouncer._forceReconnectHandler`, err);
			});
	}

	_reconnectHandler() {
		const roomNames = _.values(this._currentRooms);
		console.warn('reconnect.  rejoining rooms', roomNames);

		this.join(_.values(this._currentRooms))
			.catch(err => {
				console.error(`Bouncer._reconnectHandler`, err);
			});
	}

	deinitialize(connection = false) {
		if (!this._connectionDeferred || !this._connectionDeferred.promise.isResolved()) return;

		// if we have already been initialized with the same value then just skip it
		const oldConnection = this._connectionDeferred.promise.value;
		if (connection && oldConnection == connection) {
			console.warn(`initialized with same value.  ignoring`);
			return false;
		}

		oldConnection.off('socket_mgmt.force_reconnect', this._forceReconnectHandler);
		oldConnection.off('reconnect', this._forceReconnectHandler);

		this.__connectionDeferred = _defer();

		return true;
	}

	join(room) {
		return this._getConnection()
			.then(connection => {
				return new Promise((resolve, reject) => {
					const rooms = _.isArray(room) ? room : [ room ];

					connection.emit(this._eventNames.join, { rooms }, result => {
						if (result.success === false) {
							return reject(new Error(result.message || `unable to join room`));
						}

						result.rooms.forEach(room => {
							console.log(`joined v2 ${room.roomKey}`);
							this._currentRooms[room.roomKey] = room;
						});

						resolve(result);
					});
				});
			});
	}

	leave(room) {
		return this._getConnection()
			.then(connection => {
				// leave the room before getting a response from the server
				const rooms = _.isArray(room) ? room : [ room ];
				rooms.forEach(room => {
					console.log(`LEAVE LEAVE LEAVE ${room.roomKey}`, room);
					delete this._currentRooms[room.roomKey];
				});

				connection.emit(this._eventNames.leave, { rooms }, result => {
					if (result.success === false) {
						throw new Error(`unable to leave rooms`);
					}

					result.exits.forEach(exit => {
						console.log(`leave leave leave ${exit.roomKey}`);
						delete this._currentRooms[exit.roomKey];
					});

					return result;
				});
			});
	}

	isInRoom(roomKey) {
		return !!this._currentRooms[roomKey];
	}
}


module.exports = { Bouncer };
